import React from "react";
import {cn} from "../utils";

const UploadIcon = (
    {
        className,
        color
    }: {
        className?: string,
        color?: string
    } & React.SVGProps<SVGSVGElement>) => (
    <svg fill="none"
         height="512"
         width="512"
         viewBox="0 0 24 24"
         className={cn(className)}
         xmlns="http://www.w3.org/2000/svg">
        <path clipRule="evenodd"
              d="m6.00006 2.75c-1.79493 0-3.25 1.45507-3.25 3.25v7.6158l2.62723 1.8916c1.24084.8934 2.93663.8011 4.07313-.2217l4.09578-3.6863c1.6611-1.4949 4.1395-1.62988 5.9531-.3241l1.7508 1.2605v-2.5358c0-.41421.3357-.75.75-.75.4142 0 .75.33579.75.75v3.9915.0183 3.9902c0 2.6234-2.1267 4.75-4.75 4.75h-12.00004c-2.62336 0-4.75-2.1266-4.75-4.75v-3.9915c-.00008-.0061-.00008-.0122 0-.0183v-7.9902c0-2.62335 2.12664-4.75 4.75-4.75h8.00004c.4142 0 .75.33579.75.75s-.3358.75-.75.75zm-3.25 12.7142v2.5358c0 1.7949 1.45507 3.25 3.25 3.25h12.00004c1.7949 0 3.25-1.4551 3.25-3.25v-3.6158l-2.6273-1.8916c-1.2408-.8934-2.9366-.8011-4.0731.2217l-4.0958 3.6863c-1.66107 1.4949-4.13953 1.6299-5.95307.3241zm15.01254-13.28742c.6834-.68342 1.7915-.68342 2.4749 0l1.2929 1.29289c.2929.29289.2929.76777 0 1.06066s-.7678.29289-1.0607 0l-.7196-.71967v4.18934c0 .41421-.3358.75-.75.75-.4143 0-.75-.33579-.75-.75v-4.18934l-.7197.71967c-.2929.29289-.7678.29289-1.0607 0s-.2929-.76777 0-1.06066zm-9.26254 4.57322c-.9665 0-1.75.7835-1.75 1.75s.7835 1.75 1.75 1.75c.96649 0 1.75004-.7835 1.75004-1.75s-.78355-1.75-1.75004-1.75zm-3.25 1.75c0-1.79493 1.45507-3.25 3.25-3.25 1.79494 0 3.25004 1.45507 3.25004 3.25 0 1.7949-1.4551 3.25-3.25004 3.25-1.79493 0-3.25-1.4551-3.25-3.25z"
              fill={color || "currentColor"}
              fillRule="evenodd"
        />
    </svg>
);

export {UploadIcon};